module.exports = __webpack_public_path__ + "img/confirm.09c8b406.png";